import React from "react";
import Icon from "@ant-design/icons";
import fbIcon from "../../../assets/Svg/fb.png";
const FbImg = () => <img src={fbIcon} alt="" />;

const FbIcon = (props) => <Icon component={FbImg} {...props} />;

export default FbIcon;
